import createReactComponent from '../createReactComponent';
export default createReactComponent('cash-banknote', 'IconCashBanknote', [
  ['path', { d: 'M12 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0', key: 'svg-0' }],
  [
    'path',
    {
      d: 'M3 6m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z',
      key: 'svg-1',
    },
  ],
  ['path', { d: 'M18 12l.01 0', key: 'svg-2' }],
  ['path', { d: 'M6 12l.01 0', key: 'svg-3' }],
]);
